import React from 'react'

export default function Test() {

    function moe_login() {

        window.location= `https://www.altashkeel.net/simplesaml/module.php/core/as_login.php?AuthId=default-sp&ReturnTo=https://www.altashkeel.net/moeLogin`
        // window.location= `/simplesaml/login.php`
        // let res = await fetch(Config.saml + `login`);
        // let json = await res.json();

        // console.log(json);
        

    }
  return (
    <div>
        <a onClick={moe_login}>Login with MOE</a>
    </div>
  )
}
